import {cn} from '@rocket-ui/tools';
import {cloneElement, FC, JSX, SVGProps} from 'react';

export function createIcon(svg: JSX.Element): FC<SVGProps<SVGSVGElement>> {
	return function ({className, ...props}: SVGProps<SVGSVGElement>) {
		return cloneElement(svg, {...props, fill: 'currentColor', className: cn('w-6 h-6', className)});
	};
}
